var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "person-card",
    {
      attrs: { person: _vm.person, permissions: _vm.permissions },
      on: {
        clicked: function(clickedValue) {
          return _vm.$emit("clicked", clickedValue, _vm.person)
        }
      }
    },
    [
      _c("div", { staticClass: "flex" }, [
        _c("ul", { staticClass: "m-0" }, [
          _c("li", { staticClass: "mb-1 fs-3 mb-1" }, [
            _c("h4", { staticClass: "h4-label mt-0" }, [
              _vm._v(
                "\n                    Staff #" +
                  _vm._s(_vm.person.sellsyadmin.staff_id) +
                  "\n                    "
              ),
              _c("i", {
                staticClass: "ml-2 mr-1 fa",
                class: [_vm.activeStatus.icon, _vm.activeStatus.colorClass]
              }),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.activeStatus.label) +
                  "\n                    \n                    "
              ),
              parseInt(_vm.person.sellsyadmin.staff_ownerid) == 0
                ? _c("div", { staticClass: "dinlineb" }, [
                    _c("div", { staticClass: "mx-1 chip chip-error" }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$l10n.__("Créateur")) +
                        "\n                    "
                    )
                  ])
                : _c("div", { staticClass: "dinlineb" }, [
                    _c("div", {
                      staticClass: "mx-1 chip",
                      class: [_vm.activeStaffType.icon]
                    }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.activeStaffType.label) +
                        "\n                    "
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _vm.person.sellsyadmin.staff_isAdmin ||
          parseInt(_vm.person.sellsyadmin.staff_ownerid) == 0
            ? _c("li", [
                _c("div", { staticClass: "chip chip-error" }),
                _vm._v(_vm._s(_vm.$l10n.__("Admin")) + "\n            ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.person.sellsyadmin.staff_type === "regular" ||
          _vm.person.sellsyadmin.staff_type === "temporary"
            ? _c("li", [
                _c("div", { staticClass: "chip chip-primary" }),
                _vm._v(_vm._s(_vm.$l10n.__("Collaborateur")) + "\n            ")
              ])
            : _vm._e(),
          _vm._v(" "),
          (_vm.person.sellsyadmin.staff_type === "regular" ||
            _vm.person.sellsyadmin.staff_type === "temporary") &&
          _vm.person.sellsyadmin.staff_isDecisionMaker
            ? _c("li", [
                _c("div", { staticClass: "chip chip-warning" }),
                _vm._v(_vm._s(_vm.$l10n.__("Décisionnaire")) + "\n            ")
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }